import { useEffect } from "react";
import Logo from "@/components/Logo";
import { goToLogin } from "@/auth/sso";

// Le login est centralisé sur compte.orense.ch (service d'identité orense).
// Cette page ne fait que rediriger ; PL n'a plus de formulaire de login local.
export default function Login() {
  useEffect(() => { goToLogin(); }, []);
  return (
    <div style={styles.page}>
      <Logo size={48} />
      <p style={styles.text}>Redirection vers la connexion…</p>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  page: {
    minHeight: "100vh", display: "flex", flexDirection: "column",
    alignItems: "center", justifyContent: "center", gap: 16,
    background: "var(--bg-base)", color: "var(--text-muted)",
  },
  text: { fontSize: 14 },
};
